import { useFormikContext } from 'formik';
import { Form } from 'semantic-ui-react';

// To be used in conjunction with Formik as parent and Semantic Fields from
// componentsV2 as children
export default ({ children, ...props }) => {
  const { handleSubmit, handleReset } = useFormikContext();

  return (
    <Form {...props} onSubmit={handleSubmit} onReset={handleReset}>
      {children}
    </Form>
  );
};
